import React from "react";
import {
  imageCodes,
  titleCodes,
  textCodes,
  videoCodes,
} from "../../template_codes/cetaphilmm/home_page_codes";
import { FaAppStore } from "react-icons/fa";
import { FaGooglePlay } from "react-icons/fa6";

import CetaphilMobile from "../../assets/images/cetaphilmm/cetaphil-mobile.png";
import CetaphilMobile2 from "../../assets/images/cetaphilmm/cetaphil-mobile-2.png";
import pointBg from "../../assets/images/cetaphilmm/point-bg.png";

function Home() {
  return (
    <div>
      {/*                slider image                  */}
      <div class="carousel w-full">
        <div id="slide1" class="carousel-item relative w-full">
          <img src={imageCodes.banner.image} class="w-full" />
        </div>
      </div>

      {/* div backgroundImage with external image url  
            <div className="w-full bg-cover pt-10 "
                style={{ backgroundImage: `url(${imageCodes.bgImage.image})` }}
            >
                <div className="pt-40 md:pt-24 lg:pt-36 xl:pt-56 md:py-24 lg:py-32 xl:py-52 text-center md:text-right lg:text-right 
                    xl:text-right inset-x-0 bottom-0">
                    <button className="btn btn-outline rounded-full border-0 bg-[#004987] hover:bg-[#b3e1f8] hover:text-[#004987] 
                        text-[#ffffff] btn-xs lg:btn-sm xl:btn-md btn-outline mb-4 mt-14 lg:mb-4 xl:mb-4 ml-14 xl:mr-40 lg:mr-32">
                        <a href="" className="px-4 tracking-widest lowercase">{textCodes.shopNow.text}</a>
                    </button>

                    {/* <a href="#" target="_blank" className="btn btn-xs inset-x-0 bottom-0 lg:btn-sm xl:btn-md btn-outline rounded-full 
                     border-0 bg-[#004987] hover:bg-[#b3e1f8] lowercase mb-24 lg:mb-4 xl:mb-4 mr-2 xl:mr-40 lg:mr-32 hover:text-[#004987]
                     text-[#ffffff]"><p className="px-4">{textCodes.shopNow.text}</p></a> 
                </div>
            </div>
            {/*                end of slider image                  */}

      {/*                     category section                    */}

      <div className="container grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-6 pt-16 px-4">
        <div className="pt-4 pl-2">
          <h1 className="text-lg font-semibold xl:pb-8 pb-4 text-[#004987]">
            {titleCodes.categoryTitle.title}
          </h1>
          <p>{textCodes.categoryText.text}</p>
        </div>
        <div className="p-2 hover:-translate-y-1 duration-300 ...">
          <a href="https://cetaphilmyanmar.com/?cat=cleanser">
            <img src={imageCodes.category1.image} alt="Cleanser"></img>
            <p>{textCodes.cat1.text}</p>
          </a>
        </div>
        <div className="p-2 hover:-translate-y-1 duration-300 ...">
          <a href="https://cetaphilmyanmar.com/?cat=moisturizer">
            <img src={imageCodes.category2.image} alt="Moisturizer"></img>
            <p>{textCodes.cat2.text}</p>
          </a>
        </div>
        <div className="p-2 hover:-translate-y-1 duration-300 ...">
          <a href="https://cetaphilmyanmar.com/?cat=cetaphil_baby">
            <img src={imageCodes.category3.image} alt="Cetaphil Baby"></img>
            <p>{textCodes.cat3.text}</p>
          </a>
        </div>
        <div className="p-2 hover:-translate-y-1 duration-300 ...">
          <a href="https://cetaphilmyanmar.com/?cat=sun_protection">
            <img src={imageCodes.category4.image} alt="Sun Protection"></img>
            <p>{textCodes.cat4.text}</p>
          </a>
        </div>
        <div className="p-2 hover:-translate-y-1 duration-300 ...">
          <a href="https://cetaphilmyanmar.com/?cat=bright_healthy_radiance">
            <img
              src={imageCodes.category5.image}
              alt="Bright Healthy Radiance"
            ></img>
            <p>{textCodes.cat5.text}</p>
          </a>
        </div>
      </div>

      {/*                     end of category section                    */}

      {/*                     doctor recommend section                   */}
      <div className="container grid grid-cols-1 xl:grid-cols-2 pt-16 w-5/6 h-4/6">
        <div>
          <img
            src={imageCodes.doctor.image}
            alt="hero product"
            className="w-full h-80 xl:h-96 xl:w-5/6 lg:w-5/6 h-96"
          ></img>
        </div>
        <div className="pt-4 xl:pr-8 lg:pr-8">
          <h1 className="text-lg font-semibold xl:pb-8 pb-4 text-[#004987]">
            {titleCodes.doctorBrand.title}
          </h1>
          <p className="pt-4 text-justify">{textCodes.doctor1.text}</p>
          <p className="pt-2 text-justify">{textCodes.doctor2.text}</p>
        </div>
      </div>
      {/*                     end of doctor recommend section                    */}

      {/*                     feature product section                    */}
      <div className="container w-full pt-16">
        <h1 className="text-center font-semibold text-[#004987] text-xl">
          {titleCodes.featureTitle.title}
        </h1>
        <p className="text-center text-[#bfbfbf]">{textCodes.divider.text}</p>
        <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 pt-8 lg:px-24 xl:px-24 px-4">
          <div className="border m-1">
            <a href="https://cetaphilmyanmar.com/product/d3HmdYzV52KFZvbHtNTR">
              <img
                src={imageCodes.product1.image}
                alt="Cetaphil Baby Daily Lotion with Shea Butter 400ml"
                width={300}
                height="180"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <hr />
              <p className="py-4 text-center text-[#004987]">
                {textCodes.pd1.text}
              </p>
            </a>
          </div>
          <div className="border m-1">
            <a href="https://cetaphilmyanmar.com/product/YzhNgBsLGFfAzD5zwPge">
              <img
                src={imageCodes.product2.image}
                alt="Brightening Day Cream SPF 15"
                width={300}
                height="180"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <hr />
              <p className="py-4 text-center text-[#004987]">
                {textCodes.pd2.text}
              </p>
            </a>
          </div>
          <div className="border m-1">
            <a href="https://cetaphilmyanmar.com/product/cl4vkaxv934677901s6zdf0fi3p">
              <img
                src={imageCodes.product3.image}
                alt="Gentle skin cleanser 125ml New Packaging"
                width={300}
                height="180"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <hr />
              <p className="py-4 text-center text-[#004987]">
                {textCodes.pd3.text}
              </p>
            </a>
          </div>
          <div className="border m-1">
            <a href="https://cetaphilmyanmar.com/product/ff6JkdhE2VRStnpaxgFv">
              <img
                src={imageCodes.product4.image}
                alt="Pro AD Derma Skin Restoring Wash"
                width={300}
                height="180"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <hr />
              <p className="py-4 text-center text-[#004987]">
                {textCodes.pd4.text}
              </p>
            </a>
          </div>
          <div className="border m-1">
            <a href="https://cetaphilmyanmar.com/product/ShJXtch3QpmrM1divJQp">
              <img
                src={imageCodes.product5.image}
                alt="Oil Control Foam Wash for Acne-Prone Skin"
                width={300}
                height="180"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <hr />
              <p className="py-4 text-center text-[#004987]">
                {textCodes.pd5.text}
              </p>
            </a>
          </div>
          <div className="border m-1">
            <a href="https://cetaphilmyanmar.com/product/M69IGHtw503z5vSKFkY8">
              <img
                src={imageCodes.product6.image}
                alt="Daily Exfoliating Cleanser 178ml"
                width={300}
                height="180"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <hr />
              <p className="py-4 text-center text-[#004987]">
                {textCodes.pd6.text}
              </p>
            </a>
          </div>
        </div>
      </div>
      {/*                     end of feature product section                    */}

      {/*                     hero product section                    */}
      <div className="container grid grid-cols-1 xl:grid-cols-2 pt-16 w-5/6 h-4/6">
        <div className="grid grid-cols-2">
          <div>
            <img src={imageCodes.heropd1.image} alt="hero product"></img>
          </div>
          <div>
            <img src={imageCodes.heropd3.image} alt="hero product"></img>
          </div>
          <div>
            <img src={imageCodes.heropd2.image} alt="hero product"></img>
          </div>
          <div>
            <img src={imageCodes.heropd5.image} alt="hero product"></img>
          </div>
        </div>
        <div>
          <img src={imageCodes.heropd4.image} alt="hero product"></img>
        </div>
      </div>
      {/*                     end of hero product section                    */}

      {/*                     series product section                    */}
      <div className="container w-full pt-16">
        <h1 className="text-center font-semibold text-[#004987] text-xl">
          {titleCodes.seriesTitle.title}
        </h1>
        <p className="text-center text-[#bfbfbf]">{textCodes.divider.text}</p>
        <div className="grid grid-cols-2 lg:grid-cols-4 xl:grid-cols-4 pt-8 lg:px-24 xl:px-24 px-4">
          <div className="border m-1">
            <a href="https://cetaphilmyanmar.com/product/vXuQ0GOJmJCOz4R1Hyx3">
              <img
                src={imageCodes.serie1.image}
                alt="Gentle Cleanser 29ml + Moisturizer Cream 15g + Sun Light Gel 10ml"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <hr />
              <p className="py-6 text-center text-[#004987]">
                {textCodes.series1.text}
              </p>
            </a>
          </div>
          <div className="border m-1">
            <a href="https://cetaphilmyanmar.com/product/cl4iducl213923901s6kfl7yunn">
              <img
                src={imageCodes.serie4.image}
                alt="Gentle 29ml + Moisture 15g set"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <hr />
              <p className="py-6 text-center text-[#004987]">
                {textCodes.series2.text}
              </p>
            </a>
          </div>
          <div className="border m-1">
            <a href="https://cetaphilmyanmar.com/product/F5AII3Ys2zMt7fDcpWro">
              <img
                src={imageCodes.serie3.image}
                alt="UVA + Gentle Cleanser + Moisturizing Cream Set"
                width={322}
                height="180"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <hr />
              <p className="py-6 text-center text-[#004987]">
                {textCodes.series3.text}
              </p>
            </a>
          </div>
          <div className="border m-1">
            <a href="https://cetaphilmyanmar.com/product/sP18sAt9Zcmo0GXvank6">
              <img
                src={imageCodes.serie2.image}
                alt="Gentle Skin Cleanser 59ml + Moisturizing Lotion 59ml set"
                className="hover:-translate-y-1 duration-300 ..."
              ></img>
              <hr />
              <p className="py-6 text-center text-[#004987]">
                {textCodes.series4.text}
              </p>
            </a>
          </div>
        </div>
      </div>
      {/*                     end of series product section                    */}

      {/*                     video section                    */}
      <div className="container w-full xl:w-4/6 lg:w-4/6 pt-16">
        <h1 className="text-center font-semibold text-[#004987] text-xl pb-4">
          Get it on website
        </h1>
        <iframe
          src={videoCodes.video1.video}
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          className="w-full h-96"
        ></iframe>
      </div>
      {/*                   end of video section                 */}

      <div
        className=" my-10 md:my-20 text-[#004987]"
        style={{
          backgroundImage: `url(${pointBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="flex flex-col md:flex-row items-center justify-between gap-10  max-w-7xl mx-auto py-20 px-5 md:px-20">
          <div className="space-y-5 md:space-y-10">
            <h6 className="font-bold text-xl md:text-2xl uppercase">
              Join Our Members Community
            </h6>
            <p>
              Cetaphil app လေး down ပြီး points တွေဆုပြီး
              လက်ဆောင်တွေလဲလှယ်လို့ရပါပြီ။
            </p>
            <div className="flex items-center gap-5">
              <button className="border border-[#004987] py-2 px-8 rounded-md cursor-pointer">
                <FaGooglePlay className="text-[#004987] text-xl md:text-2xl" />
              </button>
              <button className="border border-[#004987] py-2 px-8 rounded-md cursor-pointer">
                <FaAppStore className="text-[#004987] text-xl md:text-2xl" />
              </button>
            </div>
          </div>
          <div className="w-[min(100%,500px)]">
            <img
              src={CetaphilMobile}
              className=" object-contain"
              alt="cetaphil mobile app"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
